import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import OfferAuthorizedSignatoryStaffPanel from '../../../widgets/offerAuthorizedSignatoryStaff/OfferAuthorizedSignatoryStaffPanel'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getNotMakeContract } from '../../../redux/actions/contract'
import NotMakeContractPanel from '../../../widgets/makeContract/NotMakeContractPanel'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'

export default function RequestNotMakeContract() {
  // มีคำร้องขอไม่ทำสัญญา
  const [isEditAll, setIsEditAll] = useState(false)
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getNotMakeContract(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms && (
          <>
            <AgreementAdditionalWidgets
              showCommandButton={true}
              formSchema={schema.forms.requestDetails}
            />

            <NotMakeContractPanel
              showCommandButton={true}
              isEditAll={isEditAll}
              schema={schema.forms}
              isStaff={true}
               onSuccess={() => handleGetSchema(projectId)}
            />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
